module.exports = __webpack_public_path__ + "bullying-d1393d9a22c46ff4cc64da99d8b610db.svg";